import React from 'react';
import AppWrapper from '../../app-views/app';
import ErrorPage from '../../app-views/error-page';
import Connect from '../../app-views/connect';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '../../index.css';
import { enums } from '../../utils';

export const getRoutes = () => {
  return [
    {
      path: enums.AppPaths.home,
      element: <AppWrapper />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: enums.AppPaths.home,
          element: <Connect />,
        },
        {
          path: enums.AppPaths.connect,
          element: <Connect />,
        },
      ],
    },
    /**
    * The redirect from Agent Portal to Surround when someone hits the /tasks path happens at the CDN level.
    * The /tasks path isn't actually used in Agent Portal itself anymore and this path just returns an empty element/component, 
    * but leaving this here to prevent any potential issues or errors if the redirect takes a little longer than expected.
    */
    {
      path: enums.AppPaths.tasks,
      element: <></>,
      errorElement: <ErrorPage />,
    },
  ];
};

const AppRouter = () => {
  const router = createBrowserRouter(getRoutes());
  return <RouterProvider router={router} />;
};

export default AppRouter;
